import * as React from "react";
const SvgFiRrSearchHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-search-heart_svg__a)">
      <path
        fill="#062147"
        d="m23.72 22.3-5.96-5.96c3.496-4.277 2.864-10.578-1.413-14.074C12.071-1.231 5.77-.598 2.274 3.678S-.591 14.255 3.686 17.752a10 10 0 0 0 12.661 0l5.96 5.96A.999.999 0 0 0 23.72 22.3M2.044 10.025a7.988 7.988 0 1 1 7.989 7.988 8 8 0 0 1-7.989-7.988M12.03 6.03a2.89 2.89 0 0 0-1.997.815 2.89 2.89 0 0 0-1.998-.815A3.105 3.105 0 0 0 5.04 9.226c0 1.997 2.038 4.057 3.748 5.432.728.58 1.76.58 2.489 0 1.71-1.375 3.748-3.435 3.748-5.432A3.105 3.105 0 0 0 12.03 6.03m-1.991 7.07c-1.852-1.488-3.002-2.976-3.002-3.874a1.11 1.11 0 0 1 .998-1.198c.604.06 1.049.593.999 1.198a.999.999 0 1 0 1.997 0 1.11 1.11 0 0 1 .999-1.198c.604.06 1.048.593.998 1.198 0 .898-1.15 2.386-2.99 3.874"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-search-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSearchHeart;
